import { VariantProps } from '@stitches/react'
import { IconName } from 'components/Icon/iconNames'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { CircledIcon } from '../CircledIcon'
import { Background, BlobTitleRoot, IconContainer, TextContainer } from './BlobTitle.styles'

type BlobTitleVariants = VariantProps<typeof BlobTitleRoot>

type BlobTitleProps = BlobTitleVariants & {
  title: string
  subtitle: string
  icon: IconName
  blob: string
}

export const BlobTitle = ({ title, subtitle, icon, blob, variant }: BlobTitleProps) => {
  return (
    <BlobTitleRoot variant={variant}>
      <Background
        css={{
          backgroundImage: `url(${blob})`,
        }}
      >
        <TextContainer>
          <Stack direction="column" gap="2">
            <Text weight="semiBold" as="h2" size="h2">
              {title}
            </Text>
            <Text weight="semiBold">{subtitle}</Text>
          </Stack>
        </TextContainer>
        <IconContainer>
          <CircledIcon icon={icon} />
        </IconContainer>
      </Background>
    </BlobTitleRoot>
  )
}
